/**
 * Format public name to display only the First Name for privacy on public booking screens.
 * @param {string} fullName 
 * @returns {string}
 */
export const formatPublicName = (fullName) => {
  if (!fullName || typeof fullName !== 'string') return '';
  const trimmed = fullName.trim();
  if (!trimmed) return '';
  const parts = trimmed.split(/\s+/);
  return parts[0] || trimmed;
};

/**
 * Formats FAQ answer text to ensure proper line breaks, paragraph separations,
 * and markdown bold headings across the App and Admin Panel.
 * Specifically handles Driver Knowledge Base Category A Q2 (vehicle registration documents & photos)
 * and all FAQ answers with bold sub-headings or squashed paragraphs.
 * 
 * @param {string} text 
 * @returns {string}
 */
export const formatFaqAnswerText = (text) => {
  if (!text || typeof text !== 'string') return '';
  let res = text
    .replace(/\\r\\n/g, '\n')
    .replace(/\\n/g, '\n')
    .replace(/\r\n/g, '\n')
    .replace(/^(?:\*\*A:\*\*|A:|Answer:|\*\*Answer:\*\*)\s*/i, '')
    .replace(/\[\s*\?\s*\]/g, '')
    .replace(/\[CONTACT_OPERATOR\]/g, '')
    .replace(/\[EMERGENCY_SOS\]/g, '')
    .replace(/[\p{Extended_Pictographic}\uFE0F\u200D\uFFFD\u25A1]+/gu, '')
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/^[ \t]+/gm, '');

  // Add line breaks and paragraph separations for Driver Category A Q2:
  // Vehicle documents -> Mandatory vehicle photo -> Photo requirements
  res = res
    .replace(/(?:^|\n*)(?:\*\*)?Vehicle documents\.(?:\*\*)?\s*/i, '**Vehicle documents.** ')
    .replace(/([.!?])\s*(?:\*\*)?Mandatory vehicle photo\.(?:\*\*)?\s*/i, '$1\n\n**Mandatory vehicle photo.** ')
    .replace(/([.!?])\s*(?:\*\*)?Photo requirements\.(?:\*\*)?\s*/i, '$1\n\n**Photo requirements.** ');

  // General rule: If a sentence ends and a bold sub-heading follows without a paragraph break, insert \n\n
  res = res.replace(/([.!?])\s*(\*\*[^*]+?\.\*\*)/g, '$1\n\n$2');

  res = res.replace(/\n{3,}/g, '\n\n').trim();
  return res;
};

